import axios from 'utils/axios';

export const getServicePackagesMy = (available?: boolean) => {
  return axios.get(`/api/v1/servicepackages/my${available ? '/available' : ''}`);
};
